/**
 * Keywords that indicate non-content/administrative items
 * that should be excluded from client-facing programmes.
 */
export const PROGRAMME_EXCLUDED_KEYWORDS = [
  "management fee",
  "service charge",
  "booking fee",
  "surcharge",
  "commission",
  "handling",
  "markup",
  "admin",
  "levy",
  "fee",
];

/**
 * Returns true if the item should be included in a programme.
 * Checks title, custom_title, description, and custom_description
 * using word-boundary matching to avoid false positives (e.g. "coffee" won't match "fee").
 */
export function shouldIncludeInProgramme(item: Record<string, any>): boolean {
  const fieldsToCheck = [
    item.title,
    item.custom_title,
    item.description,
    item.custom_description,
  ]
    .filter(Boolean)
    .map((v: string) => v.toLowerCase());

  if (fieldsToCheck.length === 0) return true;

  return !PROGRAMME_EXCLUDED_KEYWORDS.some((keyword) => {
    const pattern = new RegExp(`\\b${keyword}\\b`, "i");
    return fieldsToCheck.some((text) => pattern.test(text));
  });
}
